import { render, staticRenderFns } from "./Panoramas.vue?vue&type=template&id=331710ea&scoped=true&"
import script from "./Panoramas.vue?vue&type=script&lang=js&"
export * from "./Panoramas.vue?vue&type=script&lang=js&"
import style0 from "./Panoramas.vue?vue&type=style&index=0&id=331710ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331710ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
